import React, {useEffect} from 'react';
import * as SentryReact from '@sentry/react';
import ENV from '../environment';
const SentryWrapper = () => {
  const dsnNumber = ENV.SENTRY_DSN;
  useEffect(() => {
    if (!ENV.DEBUG_ENABLED) {
      SentryReact.init({
        dsn: dsnNumber,
        tracesSampleRate: 0.5,
        autoSessionTracking: false,
        ignoreErrors: [
          /\d+ms timeout exceeded/,
          /Internal error opening backing store for indexedDB\.open/,
          /backing store for indexedDB/,
        ],
        denyUrls: [
          /chrome-extension:\/\//,
          /extensions\//,
          /^chrome:\/\//,
          /^moz-extension:\/\//,
        ],
      });
    }

    return () => {
      SentryReact.close();
    };
  }, [dsnNumber]);

  return null;
};

export default SentryWrapper;
